import { render, staticRenderFns } from "./comparativeTable.vue?vue&type=template&id=b13090e6&scoped=true"
import script from "./comparativeTable.vue?vue&type=script&lang=js"
export * from "./comparativeTable.vue?vue&type=script&lang=js"
import style0 from "./comparativeTable.vue?vue&type=style&index=0&id=b13090e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13090e6",
  null
  
)

export default component.exports